// src/utils/api.js — auth-aware fetch wrapper

/**
 * Drop-in replacement for fetch() that automatically:
 *  1. Adds Authorization: Bearer <token> header if logged in
 *  2. Throws on HTTP 401 and clears stored auth so the app redirects to /login
 */
export function authFetch(url, options = {}) {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  return fetch(url, { ...options, headers }).then((res) => {
    if (res.status === 401) {
      // Token expired or invalid — clear storage and force re-login
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      window.location.href = '/login';
      throw new Error('Session expired. Please log in again.');
    }
    return res;
  });
}
